export default __webpack_public_path__ + "static/media/icon_file-CSV_plano-512.2d990348.webp";